<div class="container">
  <div class="offset-3 col-8">
    @if (!event?.freeEvent) {
    <p>Many thanks for registering for the {{ (event ? event.name : '...') }}.</p>

    <p>In the coming days, you will receive an invoice with instructions for payment. For any questions regarding
      invoicing
      and payment,
      contact the <a href="mailto:{{invoicingEmail}}">accounting department</a></p>
    @if (event?.url) {
    <p>For updates on programme and speakers, please visit <a href="{{event!.url!}}">the event
        website.</a></p>
    }
    <p>Should you have any additional requests, do not hesitate to contact the <a href="mailto:{{contactEmail}}">Event
        Manager.</a></p>
    <p>Looking forward to seeing you in {{ event ? event.shortLocation : '...'}}!</p>

    } @else {

    <p>Thank you for your interest in the {{ (event ? event.name : '...') }}.
      If shortlisted, you will receive a confirmation email in the coming days.</p>
    }
  </div>
</div>